(ns teamoesterreich.admin-mode.toe-list.toe-list
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [reagent.core :as r]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.toe-list.toe-sort-table :as table]
            [teamoesterreich.admin-mode.data.webSelection :as d-webSelection]
            [teamoesterreich.admin-mode.detail-filter.detail-filter-form :as filter-form]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.user :as s-user]
            [teamoesterreich.admin-mode.modal.toe-info :as toe-modal]
            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.search :refer [search]]
            [reagent-material-ui.icons.check-box-two-tone :refer [check-box-two-tone]]
            [teamoesterreich.util.log :as log]))

(defn event-value
  [^js/Event e]
  (h/event-value e))

(defn get-list [!elms !loaded !search !searchAddFields !sortCol !reverse !filter]
  (s-user/get-user-list-elements-detail
    (merge {:sort @!sortCol :reverse @!reverse}
           (filter-form/get-filter-request-part @!search @!searchAddFields @!filter))
    (fn [data]
      (reset! !elms data)
      (reset! !loaded true)
      )))

(defn get-csv-list [!search !searchAddFields !sortCol !reverse !filter]
  (s-user/csv-user-list-elements-detail
    (merge {:sort @!sortCol :reverse @!reverse}
           (filter-form/get-filter-request-part @!search @!searchAddFields @!filter))))


(defn get-sort-filter-rows [rows sort_ reverse_ filter_ detailFilter_]
  (js/console.log "res = " rows)
  (let [rows (if rows (mapv (fn [[k v]] (assoc v :index k)) rows) [])]
    rows))


(defn selected-chip [!st]
  (let [!st-selected (r/cursor !st [:selected])
        !selection-uuid (r/cursor vstate/app-state [:selected-elements :list-uuid])
        !selection-loaded (r/cursor vstate/app-state [:selected-elements :loaded])
        !selectionLists-loaded (r/cursor vstate/app-state [:selected-elements :lists-loaded])]
    [mui/chip {:style     {:verticalAlign "center" :margin "0px 0 7px 0"}
               :color     "primary"
               :clickable true
               :icon      (r/as-element [add])
               :title     "Zur aktuellen Auswahl hinzufügen"
               :label     (str (count (filter second @!st-selected)) " Einträge zur Auswahl hinzufügen")
               :onClick   (fn [] (d-webSelection/>add-user @!selection-uuid (mapv first (filter second @!st-selected))
                                                           (fn []
                                                             (reset! !st-selected {})
                                                             (reset! !selectionLists-loaded false)
                                                             (reset! !selection-loaded false))))
               }]
    ))

(defn select-all [!st allIds]
  (let [!selected (r/cursor !st [:selected])]
    [mui/icon-button
     {:title   "Alle auswählen"
      :onClick (fn []
                 (log/debug "count all " (count allIds))
                 (let [selUnSel (not (= (count (filter second @!selected)) (count allIds)))
                       res (into {} (map (fn [e] [e selUnSel]) allIds))]
                   (reset! !selected res)
                   ))}
     [check-box-two-tone]]
    ))



(defn table-column [!st !elms]
  (let [!elms (r/cursor !st [:data])
        !sort (r/cursor !st [:sort])
        !reverse (r/cursor !st [:reverse])
        !search (r/cursor !st [:search])
        !filter (r/cursor !st [:filter])
        !searchAddFields (r/cursor vstate/app-state [:toe-list :searchAddFields])
        !sortCol (r/cursor vstate/app-state [:toe-list :sort])
        !detail-search (r/cursor !st [:detail-search])
        rows (get-sort-filter-rows (get @!elms "rows") @!sort @!reverse @!search @!detail-search)
        all (get @!elms "ids")
        cnt-rows (get @!elms "cnt")]
    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "flex-start"
      :alignItems "flex-start"
      :style      {:height "100%"}
      }
     [mui/grid
      {:item  true
       :xs    12
       :style {:margin "0px 0 0 0"}
       }
      [mui/grid
       {:container  true
        :direction  "row"
        :alignItems "flex-start"
        :justify    "flex-start"

        }
       [mui/grid
        {:item  true
         :xs    2
         :style {:text-align "left" :paddingLeft "17px"}
         }
        [select-all !st all]
        ]

       [mui/grid
        {:item  true
         :xs    5
         :style {:text-align "left"}
         }
        [selected-chip !st]
        ]

       [mui/grid
        {:item  true
         :xs    5
         :style {}
         }
        [mui/chip {:style    {:verticalAlign "center" :margin "0px 0 7px 0"}
                   :disabled true
                   :icon     (r/as-element [search])
                   :title    "Zur aktuellen Auswahl hinzufügen"
                   :label    (str cnt-rows " Einträge gefunden")}]

        [mui/button {:style    {:verticalAlign "center" :margin "0px 0 7px 10px"}
                     :variant "outlined"
                     :onClick  #(get-csv-list !search !searchAddFields !sortCol !reverse !filter)
                     } "CSV Export"]
        ]

       ]]

     [mui/grid
      {:item  true
       :xs    12
       :style {:height "100%"}
       }
      (if (> cnt-rows 0)
        [(table/table !st rows)]
        [:h3 "Keine Ergebnisse gefunden!"])]]
    ))

(defn render-table []
  (let [!st (r/cursor vstate/app-state [:toe-list])
        !search (r/cursor vstate/app-state [:toe-list :search])
        !filter (r/cursor !st [:filter])
        !searchAddFields (r/cursor vstate/app-state [:toe-list :searchAddFields])
        !sortCol (r/cursor vstate/app-state [:toe-list :sort])
        !reverse (r/cursor vstate/app-state [:toe-list :reverse])
        !elms (r/cursor vstate/app-state [:toe-list :data])
        !map-userPopup (r/cursor vstate/app-state [:toe-map :activeUserPopup])
        !loaded (r/cursor vstate/app-state [:toe-list :loaded])]
    (fn []
      [mui/grid
       {:container  true
        :direction  "row"
        :alignItems "stretch"
        :justify    "flex-start"
        :style      {:height "calc(100% - 64px)"}
        }
       [mui/grid
        {:item  true
         :xs    12
         :style {:height "50px"}
         }
        [mui/typography {:variant "h5" :style {:margin "12px 0 0 0"}
                         :onClick (fn [] (reset! !loaded false))}
         "Detail Suche"]]
       [toe-modal/get-modal !map-userPopup]
       [mui/grid
        {:item  true
         :lg    12
         :xs    12
         :style {:padding "15px"}
         }
        [filter-form/filter-form !st true]
        ]

       [mui/grid
        {:item  true
         :lg    12
         :xs    12
         :style {:height "calc(100% - 145px)"}
         }
        (if-not @!loaded
          (do
            (get-list !elms !loaded !search !searchAddFields !sortCol !reverse !filter)
            [mui/grid
             {:item  true
              :lg    12
              :xs    12
              :style {:height "calc(100% - 145px)"}
              }
             [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40 :style {:marginTop "40px"}}]
             [mui/typography {} "Lade Daten ... "]
             ]
            )
          [table-column !st]
          )
        ]
       ]
      )))

(defn get-it []
  [(render-table)])